const isLocalhost = process.env.VUE_APP_LOCALHOST === "1";

export const apiBaseUrl = isLocalhost
  ? "/api"
  : process.env.VUE_APP_API_BASE_URL;
export default {
  apiBaseUrl,
};
console.log(process.env);
